import React from "react";
import { useTranslation } from "react-i18next";
import CardHeader from "../ui/CardHeader";
import Heatmap from "../charts/Heatmap";

/**
 * CallsByHourCard — `flat-card` wrapper around the 7×24 hour heatmap.
 *
 * Props:
 *   matrix: number[7][24]
 */
const CallsByHourCard = ({ matrix }) => {
  const { t } = useTranslation();
  return (
    <div className="flat-card rounded-xl p-6 sm:p-8">
      <CardHeader
        icon="schedule"
        title={t("analytics.callsByHour.title")}
        subtitle={t("analytics.callsByHour.subtitle")}
      />
      <Heatmap matrix={matrix} />
    </div>
  );
};

export default CallsByHourCard;
